import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionsSettingsComponent } from './fields-interventions-settings.component';
import {DxPopupModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsSettingsComponent],
    imports: [
        CommonModule,
        DxPopupModule
    ],
  exports: [FieldsInterventionsSettingsComponent]
})
export class FieldsInterventionsSettingsModule { }
